import {postRequest} from "../base/api-server";

class PickAPIs {

    getRequestPickList = async (routeCode) => {
        return routeCode ? this.assignPickList(routeCode) : this.assignTopPriorityPickList();
    }

    assignPickList = async (routeCode) => {
        return await postRequest("/sps/picklist/assignByCode", {code: routeCode});
    }

    assignTopPriorityPickList = async () => {
        return await postRequest("/sps/picklist/assignTopPriority", {});
    }

    reportIssueForItem = async (picklistId, itemId, issueType, problemSolveId) => {
        // repository.updatePickProgress(value.getPickProgress());
        // repository.setPickStatus(value.getPickStatus());
        // final Item item = repository.updateItemStatus(itemId,
        //     issueType == IssueType.MISSING ? ItemStatus.MISSED : ItemStatus.DAMAGED);
        return await postRequest("/sps/picklist/item/reportIssue", {
            itemId: itemId,
            issueType: issueType,
            picklistId: picklistId,
            problemSolveAreaId: problemSolveId
        });
    }

    addCartToPicklist = async (cartId, picklistId) => {
        return await postRequest("/sps/picklist/cart/add", {
            cartId: cartId,
            picklistId: picklistId,
            forceAdd: false // default value
        });
    }

    moveItemToCart = async (cartId, picklistId, itemId) => {
        return await postRequest("/sps/picklist/item/move", {
            cartId: cartId,
            picklistId: picklistId,
            itemId: itemId
        });
    }

    reportIssueForCart = async (cartId, picklistId, issueType) => {
        return await postRequest("/sps/picklist/cart/reportIssue", {
            cartId: cartId,
            issueType: issueType,
            picklistId: picklistId
        });
    }

    stageCart = async (cartId, picklistId, stageId, isPreStaging) => {
        return await postRequest("/sps/cart/stage", {
            cartId: cartId,
            stageId: stageId,
            picklistId: picklistId,
            preStaging: isPreStaging,
            nonMandatoryInstructionSkipAck: false, // default value for picking
            instructionSeqNo: Number.MIN_SAFE_INTEGER, // default value for picking
        });
    }

//    list of APIs not implemented
//     "sps/cart/moveFromFloor" - staging
//     "sps/route/staging/end/notify" - SSP
//     "sps/route/picking/end/notify" - SSP
//     "sps/route/picking/start/notify" - SSP
//     "sps/assign/route" - SSP
//     "sps/assign/priorityRoute" - RPS
}

const PickAPIsInstance = new PickAPIs();
export default PickAPIsInstance;


// WEBPACK FOOTER //
// ./src/network/apis/pick-apis.js